import { render, staticRenderFns } from "./PayPalButton.vue?vue&type=template&id=185e18fa&scoped=true&"
import script from "./PayPalButton.vue?vue&type=script&lang=js&"
export * from "./PayPalButton.vue?vue&type=script&lang=js&"
import style0 from "./PayPalButton.vue?vue&type=style&index=0&id=185e18fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e18fa",
  null
  
)

export default component.exports